export function formatNumber(value) {
  return Number(value).toLocaleString();
}
